import React from "react";
import { Box, Flex, Text } from "@chakra-ui/react";
import { useLandingTheme } from "../../LandingThemeContext";
import { ScoreDotPlot } from "./ScoreDotPlot";
import { SplitSection } from "./ThemedLayout";

// The number that matters most, set large under the title; the full table beside it.
function HeadlineStat() {
  const theme = useLandingTheme();
  return (
    <Flex align="baseline" gap="14px" mt="36px">
      <Text fontFamily={theme.font.display} fontWeight={theme.heading.weight} fontSize={{ base: "64px", md: "88px" }} lineHeight={0.9} color={theme.chart.jungle} letterSpacing="-0.03em">
        69
      </Text>
      <Box fontFamily={theme.font.body} lineHeight={1.35}>
        <Text fontSize="15px" fontWeight={600} color={theme.color.heading}>
          for believable wrong answers
        </Text>
        <Text fontSize="14px" color={theme.color.muted}>
          The best rival scores 56. It's the hardest thing to get right.
        </Text>
      </Box>
    </Flex>
  );
}

export function ThemedQualitySection() {
  return (
    <SplitSection
      figureNumber={2}
      figureLabel="Question quality"
      title="We really care about question quality."
      body="No one wants to flip through a hundred obvious or irrelevant questions, so we score ours against four competitors with the same judge."
      align="center"
    >
      <ScoreDotPlot />
    </SplitSection>
  );
}

export { HeadlineStat };
